import * as types from '../mutationTypes'
import { fetchJSON, endpoints } from '../../modules/fetch'
import _ from 'lodash'
import queryString from 'query-string'

const state = {
  selectedMeetingTypeId: null,
  selectedMeetingType: null,
  meetingSlots: null,
  meetingQuestions: null,
  meetingCalendars: null,
  createdMeeting: null
}

const getters = {
  selectedMeetingTypeId: state => state.selectedMeetingTypeId,
  selectedMeetingType: state => state.selectedMeetingType,
  meetingSlots: state => state.meetingSlots,
  meetingQuestions: state => state.meetingQuestions,
  meetingCalendars: state => state.meetingCalendars,
  createdMeeting: state => state.createdMeeting
}

const actions = {
  async getMeetingTypeByUrl ({ commit }, data) {
    try {
      const res = await fetchJSON(`${endpoints.meetingTypes.basicByUrl.url}/${data.prefixMeetingUrl}/${data.meetingTypeUrl}`,
        { method: 'GET' })
      if (res && res.data) {
        commit(types.SET_SELECTED_MEETING_TYPE_ID, res.data.meetingTypeId)
        commit(types.SET_SELECTED_MEETING_TYPE, res.data.meetingType)
        commit(types.SET_MEETING_CALENDARS, res.data.calendars)
        commit(types.SET_MEETING_SLOTS, res.data.slots)
        commit(types.SET_MEETING_QUESTIONS, _.orderBy(res.data.questions, 'required', 'desc'))
        return res.data
      } else {
        throw new Error('Meeting Type not found')
      }
    } catch (err) {
      return null
    }
  },
  async createMeeting ({ commit }, meeting) {
    try {
      const res = await fetchJSON(`${endpoints.meetings.create.url}`, {
        method: 'POST',
        body: meeting
      })
      commit(types.SET_CREATED_MEETING, res.data)
      return res.data
    } catch (err) {
      throw new Error('Error while creating meeting')
    }
  },
  async getMeeting ({ commit }, payload) {
    try {
      const params = queryString.stringify(payload.params) !== '' ? `?${queryString.stringify(payload.params)}` : ''
      const res = await fetchJSON(`${endpoints.meetings.get.url}/${payload.meetingIdEnc}${params}`, {
        method: 'GET'
      })
      if (res) {
        return res.data
      } else {
        throw new Error('Meeting not found')
      }
    } catch (err) {
      throw err
    }
  },
  async cancelMeeting ({ commit }, payload) {
    try {
      await fetchJSON(`${endpoints.meetings.cancel.url}/${payload.meetingIdEnc}`, {
        method: 'POST',
        body: payload.body
      })
    } catch (err) {
      throw err
    }
  },
  async rescheduleMeeting ({ commit }, payload) {
    try {
      const res = await fetchJSON(`${endpoints.meetings.reschedule.url}/${payload.meetingIdEnc}`, {
        method: 'POST',
        body: payload.body
      })
      commit(types.SET_CREATED_MEETING, res.data)
      return res.data
    } catch (err) {
      throw new Error('Error while reschedule meeting')
    }
  },
  async getGeneralSettings ({ commit }, url) {
    try {
      const params = queryString.stringify({ url }) !== '' ? `?${queryString.stringify({ url })}` : ''
      const res = await fetchJSON(`${endpoints.settings.get.url}${params}`, {
        method: 'GET'
      })
      if (res) {
        return res.data
      } else {
        throw new Error('Settings not found')
      }
    } catch (err) {
    }
  }
}

const mutations = {
  [types.SET_SELECTED_MEETING_TYPE_ID] (state, meetingTypeId) {
    state.selectedMeetingTypeId = meetingTypeId
  },
  [types.SET_SELECTED_MEETING_TYPE] (state, meetingType) {
    state.selectedMeetingType = meetingType
  },
  [types.SET_MEETING_SLOTS] (state, slots) {
    state.meetingSlots = slots
  },
  [types.SET_MEETING_CALENDARS] (state, calendars) {
    state.meetingCalendars = calendars
  },
  [types.SET_MEETING_QUESTIONS] (state, questions) {
    state.meetingQuestions = questions
  },
  [types.SET_CREATED_MEETING] (state, meeting) {
    state.createdMeeting = meeting
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
